<script setup>
  import { computed } from 'vue';
  import AccordionItem from '@/components/Utility/AccordionItem.vue';

  const props = defineProps({
    items: JSON,
    textLeft: String,
  })

  const items = computed(() => {
    return JSON.parse(props.items)
  })

</script>

<template>
  <section
    class="element-accordeon ~mt-20/28 max-w-screen-2xl mx-auto px-6"
  >
    <GridLayout>
      <LeftHeadline
        :text="textLeft"
      />
      <div
        class="element-accordeon-items lg:col-span-8"
      >
        <AccordionItem
          v-for="(item,index) in items"
          :key="index"
          :item="item"
        />
      </div>
    </GridLayout>
  </section>
</template>

<style lang="scss" scoped>

</style>
